import { render, staticRenderFns } from "./QuotationsAdd.vue?vue&type=template&id=2831888f&scoped=true&"
import script from "./QuotationsAdd.vue?vue&type=script&lang=js&"
export * from "./QuotationsAdd.vue?vue&type=script&lang=js&"
import style0 from "./QuotationsAdd.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./QuotationsAdd.vue?vue&type=style&index=1&id=2831888f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2831888f",
  null
  
)

export default component.exports